// nextShow.js — qué viene después.
//
// 🔴 **La fuente ya NO es WordPress** (26.08.26): sale del servidor de la radio.
// Ver `services/programmes.js`.
//
// Con el cambio desaparecen dos cosas que había aquí y eran deuda:
//
//   · El `setInterval` de módulo que refrescaba el caché **al importar el
//     archivo**, aunque nadie estuviera mirando la programación. El caché vive
//     ahora en `programmes.js`, con su TTL, y no hay temporizadores sueltos.
//   · El mapeo `stationId === '3' ? 1 : 0`, que elegía parrilla por índice
//     dentro del array de WordPress.
import { getNextProgramme, getTodayProgrammes } from "@/services/programmes";

/** El siguiente programa; tras el último del día, el primero. */
export async function getNextShow() {
  const p = await getNextProgramme();
  if (!p) return null;

  return {
    name: p.name,
    range: p.range,
    generos: p.genres,
    subGeneros: [],
    subtitle: p.resident,
    image: p.image,
    description: p.description,
    startTime: p.startTime,
    endTime: p.endTime,
    slug: p.slug,
    genre: p.genre,
    resident: p.resident,
    residentImage: p.residentImage,
    days: p.days,
  };
}

/**
 * Los tres siguientes. Lo sigue usando la web antigua; la parrilla del reset
 * pide el día entero con `getTodayShows`.
 */
export async function getNext3Shows() {
  const lista = await getTodayProgrammes();
  if (!lista.length) return [];

  const desde = lista.findIndex((p) => p.live);
  const inicio = desde === -1 ? 0 : desde + 1;

  // Da la vuelta al día: después del último vuelve el primero.
  return Array.from({ length: Math.min(3, lista.length) }, (_, i) => {
    const p = lista[(inicio + i) % lista.length];
    return {
      name: p.name,
      range: p.range,
      generos: p.genres,
      subtitle: p.resident,
      image: p.image,
      description: p.description,
      startTime: p.startTime,
      endTime: p.endTime,
      slug: p.slug,
      resident: p.resident,
    };
  });
}
